module.exports = __webpack_public_path__ + "img/ic_public.080b3e4c.svg";